"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactDom = _interopRequireDefault(require("react-dom"));
var _lodash = _interopRequireDefault(require("lodash"));
var _transactableModal = require("../shared-components/modal/transactable-modal");
var _searchModal = require("./search-modal");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
var ActivityModal = /*#__PURE__*/function (_React$Component) {
  _inherits(ActivityModal, _React$Component);
  function ActivityModal(props) {
    var _this;
    _classCallCheck(this, ActivityModal);
    _this = _callSuper(this, ActivityModal, [props]);
    _this.state = {
      activityID: null,
      activityValue: null
    };
    _this.handleClickOutside = _this.handleClickOutside.bind(_assertThisInitialized(_this));
    _this.activityModalBody = _this.activityModalBody.bind(_assertThisInitialized(_this));
    _this.closeBehavior = _this.closeBehavior.bind(_assertThisInitialized(_this));
    _this.handleListClick = _this.handleListClick.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass(ActivityModal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.closeDropdown) {
        analyticsIntegrations.locationModal(this.props.origin);
        this.props.closeDropdown();
      }
    }
  }, {
    key: "handleClickOutside",
    value: function handleClickOutside() {
      this.setState({
        isOpened: false
      });
    }
  }, {
    key: "activityModalBody",
    value: function activityModalBody() {
      var _this2 = this;
      var activities = this.props.activities;
      var alphaActivites = _lodash.default.sortBy(activities, 'dropdown');
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "container-fluid"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "row"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "col-xs-12"
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: "col-xs-12"
      }, /*#__PURE__*/_react.default.createElement("ul", null, _lodash.default.map(alphaActivites, function (act, i) {
        return /*#__PURE__*/_react.default.createElement("div", {
          key: "activity_".concat(i),
          className: "col-xs-12 col-sm-6"
        }, /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("a", {
          onClick: _this2.handleListClick
          // data-value={m.nickname}
          // data-geo={metro.map_boundaries}
          ,
          "data-name": act.dropdown,
          "data-id": act.id,
          href: "#"
        }, act.dropdown)));
      })))));
    }
  }, {
    key: "closeBehavior",
    value: function closeBehavior(e) {
      if (e) {
        $('#modal-container').modal('hide');
        return _reactDom.default.unmountComponentAtNode(document.getElementById('modal-container'));
      }
      return _reactDom.default.render( /*#__PURE__*/_react.default.createElement(_searchModal.SearchModal, {
        nickname: this.state.nickname,
        activityValue: this.state.activityValue,
        activityID: this.state.activityID,
        location: this.props.location
      }), document.getElementById('modal-container'));
    }
  }, {
    key: "handleListClick",
    value: function handleListClick(e) {
      var _this3 = this;
      e.persist();
      window.scrollTo(0, 0);
      if ('modal' !== this.props.origin) {
        if (!this.props.handleActivityClick) {
          return;
        } else {
          this.props.handleActivityClick(e);
          return this.closeBehavior(e);
        }
      }
      var activityValue = e.currentTarget.getAttribute('data-name');
      var activityID = e.currentTarget.getAttribute('data-id');
      this.setState({
        activityValue: activityValue,
        activityID: activityID
      }, function () {
        return _this3.closeBehavior();
      });
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement(_transactableModal.Modal, {
        show: true,
        addCloseIcon: true,
        modalType: "standard",
        modalID: "location-modal",
        modalSize: 'sm-size',
        body: this.activityModalBody(),
        header: "Popular Activities",
        footer: null,
        closeBehavior: this.closeBehavior
      });
    }
  }]);
  return ActivityModal;
}(_react.default.Component);
ActivityModal.propTypes = {
  closeDropdown: _propTypes.default.func,
  origin: _propTypes.default.string,
  activities: _propTypes.default.array,
  location: _propTypes.default.string
};